import React from 'react'
import '../styles/Productreviewcard.css'

const Productreviewcard = ({price,name,index,image,review}) => {
    return (
    <>
     <div className="productreviewcard">
        <img src={image} alt={`${index} review`}></img>  
        <h5>{review}</h5>
        <span>{name}</span>
        <b>{price}</b>
     </div>      
    </>
    )
}

export default Productreviewcard
